module.exports = __webpack_public_path__ + "static/media/teacher3.89fe4986.svg";